import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SpcCsvImportView } from "src/components/views/spc/controlChart/dataImport/SpcCsvImportView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/importData")({
	staticData: { title: i18n.t("import_csv"), legacyViewKey: "importSpcDataView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SpcCsvImportView />;
}
